export enum NestedMenuItemLevels {
  firstLevelWithChildren = 1,
  nestedLevelWithChildren = 222,

  firsLevelAlone = 100,
}
